/**
 * Transaction types that are fee income. `income` is not: it is a generic
 * bucket the other screens never counted.
 *
 * Kept here, with no imports, so code outside the app (the Claude connector)
 * reads the same list; utils/feeIncome.ts re-exports it and remains the one
 * place the fee figures are defined.
 */
export const FEE_INCOME_TYPES = new Set(['payment_received', 'commission_payment'])
